/*
  vuex 相关文档链接：http://vuex.vuejs.org/zh-cn/
*/
import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import purchase from './modules/purchase'
import inventory from './modules/inventory'
import oppotunity from './modules/oppotunity'
import contract from './modules/contract'
import cti from './modules/cti'
import product from './modules/product'
import payment from './modules/payment'
import customer from './modules/customer'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  advanced: false,
  advancedFilter: {
    /*
    supplierName: '',
    shortName: '',
    phone: '',
    country: ''
    registeredCapital: ''
    website: ''
    */
  },
  // 表头筛选
  normalFilter: {
    /*
    supplierName: '',
    shortName: '',
    phone: '',
    country: ''
    registeredCapital: ''
    website: ''
    */
  },
  freshList: false, // 刷新列表
  sortObj: {
    /*
    sort: '',
    order: ''
    */
  },
  // 当前的 moduleName
  moduleName: '',
  // 保存关联产品信息
  selectProducts: [],
  // 选中的行
  selectRows: {
    // id: name
  },
  // 选中的待采购
  selectPu: [],
  selectIds: [
    // id
  ],
  // 异步验证的属性名
  attr: '',
  // 消息提醒数量
  remindCount: 0,
  errorCode: 1, // 服务端返回的错误码
  detailConfig: {}, // 详情页权限配置
  listLoading: false, // 列表页的loading状态
  sidemenuStatus: false, // 侧面菜单展开,收起状态
  updateAddress: false, // 是否更新address组件的数据
  specialEnmus: {}, // 特殊枚举类
  vuexPageObj: {}, // 列表页码分类
  addNumIndex: '', // 扫码增加1序号初始
  aliasList: [], // 菜单自定义
  freshAllList: false // 刷新列表
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    purchase,
    inventory,
    oppotunity,
    contract,
    cti,
    product,
    payment,
    customer
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js